<h3>Shipping Prices</h3>
<div *ngFor="let shippingCost of shippingCosts | async">
  <span> {{ shippingCost.type }} </span>
  <span> {{ shippingCost.price }} </span>
</div>